var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-badge',{attrs:{"color":_vm.customStatus,"text":_vm.item.name,"id":"project-link"},on:{"click":function($event){return _vm.clickHandle(_vm.item.path)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }